import React from "react";
import {
  Container,
} from "../Settings/Subscription/styles";
import TextView from "../TextView";
import { FeatureContainer, FeatureHeading, FeatureSubHeading, SingleColumn } from "./styles";

export const PlanComparison = ({ features }) => {

  return (
    <Container>
        <SingleColumn>
            <FeatureContainer data-compare-spacer="">
                <TextView variant="title" color="#123051">Compare Plans</TextView>
            </FeatureContainer>
            {Object.entries(features).map(([heading, subHeadings]) => (
                <div key={heading}>
                    <FeatureHeading>{heading}</FeatureHeading>
                    {subHeadings.map((subHeading, index) => (
                        <FeatureSubHeading key={index}>{subHeading}</FeatureSubHeading>
                    ))}
                </div>
            ))}
        </SingleColumn>
    </Container>
  );
};
